<template>
    <v-card>
        <v-card-title>Agendar Encomenda</v-card-title>

        <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
                <v-text-field outlined autocomplete="off" ref="phone" v-model="form.phone" label="Whatsapp para contato"
                    prepend-icon="mdi-whatsapp" v-mask="'(##) #####-####'" :rules="[rules.required, rules.phone]"
                    @keyup.enter="focusNext('date')" />

                <v-text-field placeholder="DD/MM/AAAA" outlined autocomplete="off" ref="date" v-model="form.date"
                    label="Data" prepend-icon="mdi-calendar" v-mask="'##/##/####'" :rules="[rules.required, rules.date]"
                    @keyup.enter="focusNext('time')" />

                <v-text-field placeholder="HH:MM" outlined autocomplete="off" ref="time" v-model="form.time"
                    label="Horário" prepend-icon="mdi-clock" v-mask="'##:##'" :rules="[rules.required, rules.time]"
                    @keyup.enter="submit" />
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'PreOrder',
        data() {
            return {
                valid: false,
                form: {
                    phone: '',
                    date: '',
                    time: ''
                },
                rules: {
                    required: v => !!v || 'Campo obrigatório',
                    phone: v => /^\(\d{2}\)\s?\d{4,5}-\d{4}$/.test(v) || 'Telefone inválido',
                    date: v => /^\d{2}\/\d{2}\/\d{4}$/.test(v) || 'Data inválida',
                    time: v => /^\d{2}:\d{2}$/.test(v) || 'Horário inválido'
                }
            };
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.phone?.focus();
            });
        },
        methods: {
            submit() {
                if (this.$refs.form.validate()) {
                    this.$emit('submit', this.form);
                    this.$toast.success('Encomenda salva com sucesso');
                    this.form = {
                        phone: '',
                        date: '',
                        time: ''
                    }
                }
            },
            focusNext(refName) {
                this.$nextTick(() => {
                    this.$refs[refName]?.focus();
                });
            }
        }
    };
</script>
